// extracted by css-extract-rspack-plugin
export default {"ActionList":"suggestions-list-module__ActionList__xdDbh"};